/** @format */

export const billingPeriodActionType = {
  setBillingPeriod: "SET_BILLING_PERIOD_APPLICATION",
};
